import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import ProfileList from '../profile-list'

import { RouteComponentProps } from 'react-router'
import { Operation } from '../domain/Operation'
import Loading from '../helper/loading'
import { ApplicationState } from '../redux/ApplicationState'
import Router from '../router'

interface MatchParameters {
    profile: string
}

interface OwnProps {
    operation: Operation
    params: MatchParameters
}

interface StateProps {
    router: Router
}

type Props = OwnProps & StateProps & RouteComponentProps<MatchParameters>

class Compare extends React.Component<Props> {
    public render = () => {
        this.props.router.setDefaultParameter('base', this.props.match.params.profile)

        return (
            <div>
                {!this.props.operation.id ? (
                    <Loading /> // TODO: Can we handle this more elegant (duplicate loading handling)
                ) : (
                    <ProfileList
                        params={this.props.params}
                        profileRoute="XhprofProfilerBundle.Profile.compare"
                        listRoute="XhprofProfilerBundle.Profile.listCompare"
                        showTabs={false}
                        hasArchivedTraces
                    />
                )}
            </div>
        )
    }
}

export default withRouter(
    connect(
        (globalState: ApplicationState, props: OwnProps & RouteComponentProps): StateProps => {
            return {
                router: globalState.tidewaysContext.router,
            }
        },
    )(Compare),
)
